import textAnim from '../components/text-anim';
import swiperAutoplay from '../components/swiper-autoplay';
import swiperCards from '../components/swiper-cards';
import swiperVertical from '../components/swiper-vertical-tabs';


export default {
  init() {
    // JavaScript to be fired on the home page
    textAnim();
    swiperAutoplay();
    swiperCards();
    swiperVertical();
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
